import React, { useEffect, useState } from "react";
import {Container, Grow, Grid} from "@material-ui/core";
import Posts from "../Posts/Posts";
import Form from "../Form/Form";
import { useDispatch } from "react-redux";
import {getPosts} from "../../actions/posts";
import useStyles from "../../styles.js";

function Home() {

  const [currentId, setCurrentId] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  //updating my store after every render
  useEffect( () => {
    dispatch(getPosts());
  }, [currentId, dispatch]);

  return (
    <Grow in>
       <Container>
          <Grid container className={classes.mainContainer} justify="space-between" align="stretch" spacing={3}>
             <Grid item xs={12} sm={7}>
                <Posts setCurrentId={setCurrentId} />
             </Grid>
             <Grid item xs={12} sm={4}>
                <Form currentId={currentId} setCurrentId={setCurrentId} />
             </Grid>
          </Grid>
       </Container>
    </Grow>
  );
}

export default Home;
